import { Box, Tooltip } from '@mui/material'
import { FeatureFlagIdExportData } from 'c1gen/features'
import { ExportdataV1ExportDataServiceExportData } from 'c1gen/permissions'
import { C1IconButton } from 'c1ui'
import { C1Icon } from 'components/core/icons/C1Icon'
import { useFeatureChecker, usePermissionChecker } from 'components/no-ui/capability'
import { useAlert } from 'hooks/useAlert'
import { Download } from 'lucide-react'
import { ExportDataRequest } from 'pbts/c1/api/exportdata/v1/exportdata'
import React, { FC, useCallback } from 'react'
import { useIntl } from 'react-intl'
import { exportDataApi } from 'redux_toolkit/export-data'

export const ExportData: FC<{exportDataRequest: ExportDataRequest}> = ({ exportDataRequest }): React.ReactElement | null => {
    const hasExportDataFeature = useFeatureChecker(FeatureFlagIdExportData)
    const permChecker = usePermissionChecker()
    const intl = useIntl()
    const toast = useAlert()
    const { mutate: createExportDataAction } = exportDataApi()
    const onDownloadReport = useCallback(async () => {
        try {
            await createExportDataAction({ ...exportDataRequest })
            toast('Generating CSV. It will be available in downloads when it’s done.', 'success')
        } catch (err) {
            toast(`Error exporting data: ${err}`, 'error')
        }
    }, [exportDataRequest, toast, createExportDataAction])

    if (!hasExportDataFeature) {
        return null
    }

    const canExportData = permChecker(ExportdataV1ExportDataServiceExportData)
    if (!canExportData) {
        return null
    }

    return <Tooltip title={intl.formatMessage({ id: 'components_export_data_download', defaultMessage: 'Generate CSV' })}>
        <Box mr={1}>
            <C1IconButton
                variant="outlined"
                color="info"
                aria-label={intl.formatMessage({ id: 'components_export_data_download', defaultMessage: 'Download as CSV' })}
                onClick={onDownloadReport}
            >
                <C1Icon icon={Download} />
            </C1IconButton>
        </Box>
    </Tooltip>
}
